module.exports = __webpack_public_path__ + "img/align-bottom-02.2e57b422.svg";